import { ThemeEnum } from "@taskfortress/core"
import { useEffect } from "react"

/**
 * Web implementation of useTheme hook for managing theme based on user settings and system preferences
 *
 * @param theme User's selected theme from settings
 */
export function useTheme(theme: ThemeEnum): void {
  useEffect(() => {
    // Function to update theme based on current settings and system preference
    const updateTheme = () => {
      const root = document.documentElement

      if (
        theme === ThemeEnum.DARK ||
        (theme === ThemeEnum.SYSTEM &&
          window.matchMedia("(prefers-color-scheme: dark)").matches)
      ) {
        root.classList.add("dark")
        document.documentElement.setAttribute("data-theme", "dark")
      } else {
        root.classList.remove("dark")
        document.documentElement.setAttribute("data-theme", "light")
      }
    }

    // Update theme initially
    updateTheme()

    // Listen for system preference changes
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    const handleChange = () => {
      if (theme === ThemeEnum.SYSTEM) {
        updateTheme()
      }
    }

    // Add listener for system preference changes
    mediaQuery.addEventListener("change", handleChange)

    // Clean up listener when component unmounts
    return () => {
      mediaQuery.removeEventListener("change", handleChange)
    }
  }, [theme])
}
